import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);

interface CardHeaderProps {
  handleDelete: (() => void) | null;
  toggleVisibility: () => void;
  isHidden: boolean;
  cardName: string;
  notValid?: boolean;
  subTitle? : string;
}

function CardHeader({
  toggleVisibility,
  isHidden,
  cardName,
  handleDelete,
  notValid = false,
  subTitle
}: CardHeaderProps) {
  return (<>
    <div className="row">
      <div className="col-6 visibility-button" onClick={toggleVisibility}>
        <h2
          className={
            notValid
              ? "container-title error-text-important"
              : "container-title"
          }
        >
          <FontAwesomeIcon
            icon={angleDefinition}
            className={
              isHidden
                ? "text-end me-4 angle-anim rotate"
                : "text-end me-4 angle-anim"
            }
          />
          {cardName}
        </h2>
      </div>
      {handleDelete == null ? null : (
        <div className="col-6">
          <div className="text-end">
            <button
              className="delete-phase-btn btn btn-outline-danger"
              onClick={handleDelete}
            >
              <FontAwesomeIcon icon={trashcanDefinition} />
              Delete {cardName}
            </button>
          </div>
        </div>
      )}
    </div>
    
    {subTitle && !isHidden?<h5 className={
            notValid
              ? "text error-text-important"
              : "text"
          }> <br/>{subTitle}</h5>: null}</>
  );
}

export default CardHeader;
